import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getArea = async () => {
  const { data } = await axios.get(`${api_base_url}/Area`);
  return data;
};
// Insert New Area
export const addArea = async (newArea) => {
  const { data } = await axios.post(`${api_base_url}/Area`, {
    ...newArea[0],
  });
  return data;
};

//Get Area By Territory
export const getAreaByTerritoryID = async (territoryId) => {
  const { data } = await axios.get(
    `${api_base_url}/Area/GetAreaByTerritoryID/${territoryId}`
  );
  return data;
};

// Update Area
export const updateArea = async (updatedArea) => {
  const { data } = await axios.put(
    `${api_base_url}/Area/${updatedArea[0].areaId}`,
    updatedArea[0]
  );
  return data;
};
// Deactivate Area
export const deleteArea = async (ids) => {
  await axios.delete(`${api_base_url}/Area`, {
    data: ids,
  });
};
